import { useLocale, useTranslations } from "next-intl";
import useCMSPageByID from "../../cms/hooks/server/useCMSPageByID";
import NavigationItem from "./NavigationItem";

const AssortmentHighlightListItem = ({ pageId }) => {
  const normalizedPageId =
    typeof pageId === "string" ? pageId?.split("pages://")?.[1] : null;
  const locale = useLocale();
  const { page } = useCMSPageByID({ pageId: normalizedPageId, locale });

  if (!page) return null;
  return (
    <div className="col-6 col-lg-4 mb-32px">
      <NavigationItem
        key={page?._id}
        link={page?._r}
        image={page?.seo?.image}
        title={page?.title}
        imageSize={{ width: 300, height: 177 }}
        subtitle={page?.seo?.description}
      />
    </div>
  );
};

const AssortmentHighlightList = ({ highlights }) => {
  const t = useTranslations();
  if (!highlights?.length) return null;

  return (
    <div className="navigation-list-column navigation-list-column--sortiment">
      <h6 className="hide-on-mobile mt-5 mt-lg-0">{t("current_topics")} </h6>
      <div className="row only-show-4-on-mobile sortiment-highlight">
        {highlights.map((pageId, index) => (
          <AssortmentHighlightListItem
            key={`${pageId?.link}-${index}`}
            pageId={pageId}
          />
        ))}
      </div>
    </div>
  );
};

export default AssortmentHighlightList;
